import {
	gsap
} from "gsap";
import {
	Flip
} from "gsap/Flip";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";

// if (document.body.classList.contains('page-template-page-homepage')) {
document.addEventListener("DOMContentLoaded", () => {
	gsap.registerPlugin(gsap, Flip, ScrollTrigger);

	console.info('✅ GSAP loaded');

	gsap.timeline({
			scrollTrigger: {
				id: '.hero-img',
				trigger: '.section--welcome',
				start: 'top top',
				end: 'bottom top',
				scrub: 1,
				// pin: true,
				// markers: true,
			}
		})
		.fromTo('.hero-img', {
			width: '60%',
		}, {
			width: '80%',
		})


	gsap.timeline({
			scrollTrigger: {
				id: '.reviews-img',
				trigger: '.section--reviews .col-2',
				start: 'top bottom',
				end: 'bottom top',
				scrub: 1,
				// pin: true,
				// markers: true,
			}
		})
		.fromTo('.reviews-img', {
			width: '60%',
		}, {
			width: '80%',
		})

	function fadein(itemTrigger, itemSelector) {
		let scrollTriggerParam = {
			id: itemSelector,
			trigger: itemTrigger,
			start: 'top 98%',
			end: 'top 99%',
			toggleActions: "play restart reverse reverse",
			scrub: 1.5,
			// pin: true,
			// markers: true,			
		}
		gsap.timeline({
				scrollTrigger: scrollTriggerParam,
			})
			.fromTo(itemSelector, {
				y: 100,
				opacity: 0,
			}, {
				y: 0,
				opacity: 1,
			})
	}

	function flag(flagTrigger, flagSelector) {
		let scrollTriggerParam = {
			id: flagSelector,
			trigger: flagTrigger,
			start: "center center",
			end: "center cenetr",
			toggleActions: "play restart reverse reverse",
			// scrub: 1,
			// markers: true,
		}
		gsap.to(flagSelector + " .st1", {
			scrollTrigger: scrollTriggerParam,
		});
		gsap.to(flagSelector + " .st2", {
			scrollTrigger: scrollTriggerParam,
			strokeWidth: 0,
		});
		gsap.to(flagSelector + " .st1," + flagSelector + " .st3", {
			scrollTrigger: scrollTriggerParam,
			strokeWidth: 500,
		});
		gsap.timeline({
				scrollTrigger: scrollTriggerParam,
			})
			.fromTo(flagSelector + ' .pl-red', {
				height: '20%',
				y: '0%',
			}, {
				height: '100%',
				y: '22%',
			})
	}



	let movex = gsap.utils.toArray('.section--reviews ul.reviews li')
	movex.forEach((item, index) => {

	let tl = gsap.timeline({
			scrollTrigger: {
			trigger: item,
			// scrub: true,
			start:"top bottom",  // start when top of trigger target hits 50% point of viewport
			toggleActions:"restart none none reset",
			end: "bottom center",
			// markers:true
		}
		});
		tl.to(item, {
			opacity: 1,
			x:'32px',
			duration: 1,
		});
	})

	flag('.flag-hero', '.flag-hero')
	flag('.flag-whyme', '.flag-whyme')
	flag('.flag-footer', '.flag-footer')

	fadein('.section--whyme .content h2', 	'.section--whyme .content h2')
	fadein('.section--whyme .content p',	'.section--whyme .content p')
	fadein('.section--offer .content h2', 	'.section--offer .heading .content h2')
	fadein('.section--offer .content p',	'.section--offer .heading .content p')
	fadein('.section--reviews .heading',	'.section--reviews .heading .h2--light')
	fadein('.section--reviews .heading',	'.section--reviews .heading .p--light')

	
	fadein('footer .logo', 'footer .logo')
	fadein('footer .email', 'footer .email')
	fadein('footer .phone', 'footer .phone');



	// const animatedElement 		= document.querySelector("#logo");
	// const container1 			= document.querySelector("#container1");
	// const container2 			= document.querySelector("#container2");
	// const startPosition 		= document.querySelector("#container1 > img");
	// const endPosition 			= document.querySelector("#container2 > img");
	// const startPositionState 	= Flip.getState(startPosition);
	// const endPositionState 		= Flip.getState(endPosition);

	// const runTween = () => {		
	// 	Flip.fit('#container1', '#container2', {
	// 	// fitChild: 'img',
	// 	targets: animatedElement,
	// 	duration: 3,
	// 	// scale: true
	// 	})
	// }
	// container1.addEventListener("click", runTween);

	// const runTween2 = () => {		
	// 	Flip.fit('#container2 img', '#container1 img', {
	// 	targets: animatedElement,
	// 	scale: true,
	// 	duration: 3,
	// 	onComplete: () => {
	// 		console.log("DONE!!!")
	// 		animatedElement.style.display = 'none'
	// 	}
	// 	})
	// }


	// const runTween2 = () => {		
	// Flip.fit('#container1', '#container2' {
	// 	targets: animatedElement,
	// 	duration: 3,		
	// });
	// }

	// container2.addEventListener("click", runTween2);





	const container1 = document.querySelector("#container1"),
		container2 = document.querySelector("#container2"),
		box = document.querySelector("#logo");

	const state = Flip.getState(box, {
		props: ""
	});

	function flip() {
		const state = Flip.getState(box, {
			props: ""
		});

		if (box.parentElement === container1) {
			container2.appendChild(box);
			console.log('container2.appendChild');
		} 
		Flip.from(state, {
			duration: 1,
			ease: "power1.inOut"
		});
	};

	function flip2() {
		const state = Flip.getState(box, {
			props: ""
		});

		if (box.parentElement === container2) {
			container1.appendChild(box);
		} 

		Flip.from(state, {
			duration: 1,
			ease: "power1.inOut"
		});
	};

	ScrollTrigger.create({
		trigger: ".section--welcome",
		start: "top top",
		  end: "top top",
		//   markers: true,
		//   scrub: 1,

		onEnter: () => flip(),
		onEnterBack: () => flip2(),
	});



})
// }